import type { SubjectiveExamForm } from "@rmh/defs";
import { ExamFormDataInputRowType, TestKey, TestRowKey } from "@rmh/defs";
import { defaultPlaceHolderProm } from "./proms/defaults";

export const SUBJECTIVE_EXAMS = {
  exams: [
    {
      examFormId: "ADBD-ATBD-AQBL",
      examTitle: "Step 2: RF Form",
      examFormTests: [
        {
          __typename: "ExamFormTestChoice",
          testTitle: "1. RF Form - Are you currently or have you experienced:",
          subTitle:
            "1. Are you suddenly feeling short of breath, sweaty, nauseous, or having pain in your chest or left arm without a clear reason?",
          testKey: TestKey.RedCardiacArrestStroke,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle:
            "2. Do you have severe chest pain that feels like pressure, squeezing, or heaviness?",
          testKey: TestKey.RedCrushingChestPain,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle: "3. Are you coughing up blood?",
          testKey: TestKey.RedCoughingUpBlood,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle:
            "4. Are you suddenly having trouble speaking clearly, seeing, or does one side of your face feel droopy?",
          testKey: TestKey.RedSlurredSpeech,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle:
            "5. Did you suddenly lose strength or movement in one arm or one leg?",
          testKey: TestKey.RedWeakness,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle: "6. Have you lost consciousness?",
          testKey: TestKey.RedLossOfConsciousness,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle:
            "7. Have you had new or worsening trouble controlling your urine or bowel movements?",
          testKey: TestKey.RedLossOfBowel,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle:
            "8. Do you have new pain in one calf along with noticeable swelling, warmth, or redness compared to the other leg?",
          testKey: TestKey.RedCalfPain,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle:
            "9. Are you experiencing fever, chills, night sweats, or signs of a recent infection?",
          testKey: TestKey.RedFeverChills,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle:
            "10. Have you had thoughts of hurting yourself or that you would be better off dead?",
          testKey: TestKey.RedSuicidal,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle: "",
          testKey: TestKey.NoRedFlagSymptoms,
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleSelect",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedNoSymptoms,
              rowTitle:
                "Patient is currently not exhibiting any red flag symptoms",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
      ],
      order: 1,
    },
    {
      examFormId: "ADBD-ATBD-PHQ9",
      examTitle: "Step 3: YF Form / PHQ",
      examFormTests: [
        {
          __typename: "ExamFormTestChoice",
          testTitle:
            "2. Over the past 2 weeks, how often have you been bothered by any of the following problems?",
          testKey: TestKey.LittleInterestInDoingThings,
          subTitle: "Little interest or pleasure in doing things",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NotAtAll,
              rowTitle: "Not at all",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.SeveralDays,
              rowTitle: "Several days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoreThanHalfTheDays,
              rowTitle: "More than half the days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NearlyEveryDay,
              rowTitle: "Nearly every day",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle: "Feeling down, depressed or hopeless",
          testKey: TestKey.FeelingDownDepressedOrHopeless,
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NotAtAll,
              rowTitle: "Not at all",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.SeveralDays,
              rowTitle: "Several days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoreThanHalfTheDays,
              rowTitle: "More than half the days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NearlyEveryDay,
              rowTitle: "Nearly every day",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.SleepIssues,
          subTitle: "Trouble falling or staying asleep, or sleeping too much",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NotAtAll,
              rowTitle: "Not at all",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.SeveralDays,
              rowTitle: "Several days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoreThanHalfTheDays,
              rowTitle: "More than half the days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NearlyEveryDay,
              rowTitle: "Nearly every day",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.FeelingTiredOrLittleEnergy,
          subTitle: "Feeling tired or little energy",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NotAtAll,
              rowTitle: "Not at all",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.SeveralDays,
              rowTitle: "Several days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoreThanHalfTheDays,
              rowTitle: "More than half the days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NearlyEveryDay,
              rowTitle: "Nearly every day",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.PoorAppetiteOrOverEating,
          subTitle: "Poor appetite or overeating",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NotAtAll,
              rowTitle: "Not at all",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.SeveralDays,
              rowTitle: "Several days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoreThanHalfTheDays,
              rowTitle: "More than half the days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NearlyEveryDay,
              rowTitle: "Nearly every day",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.FeelingBadAboutSelf,
          subTitle:
            "Feeling bad about yourself - or that you are a failure or have let yourself or your family down",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NotAtAll,
              rowTitle: "Not at all",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.SeveralDays,
              rowTitle: "Several days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoreThanHalfTheDays,
              rowTitle: "More than half the days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NearlyEveryDay,
              rowTitle: "Nearly every day",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.TroubleConcentrating,
          subTitle:
            "Trouble concentrating on things, such as reading the newspaper or watching television",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NotAtAll,
              rowTitle: "Not at all",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.SeveralDays,
              rowTitle: "Several days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoreThanHalfTheDays,
              rowTitle: "More than half the days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NearlyEveryDay,
              rowTitle: "Nearly every day",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.PsychomotorChanges,
          subTitle:
            "Moving or speaking so slowly that other people could have noticed? Or the opposite - being so fidgety or restless that you have been moving around a lot more than usual",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NotAtAll,
              rowTitle: "Not at all",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.SeveralDays,
              rowTitle: "Several days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoreThanHalfTheDays,
              rowTitle: "More than half the days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NearlyEveryDay,
              rowTitle: "Nearly every day",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },

        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.SuicidalThoughts,
          subTitle:
            "Thoughts that you would be better off dead or of hurting yourself in some way",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NotAtAll,
              rowTitle: "Not at all",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.SeveralDays,
              rowTitle: "Several days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoreThanHalfTheDays,
              rowTitle: "More than half the days",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NearlyEveryDay,
              rowTitle: "Nearly every day",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
      ],
      order: 2,
    },
    {
      examFormId: "ADBD-ATBD-FRAT",
      examTitle: "Step 4: Falls Risk/FRAT",
      examFormTests: [
        {
          __typename: "ExamFormTestChoice",
          testTitle: "3. Falls Risk/FRAT",
          subTitle:
            "Have you experienced any falls due to losing your balance in the last year?",
          testKey: TestKey.HadFallenByLosingBalance,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.NumberOfFalls,
          comments: false,
          commentsText: "",
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.NumberOfFallsRow,
              rowTitle: "Approximately how many falls?",
              examFormDataInputRowType: "TextField",
              isTextArea: false,
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "Approximately how many falls?",
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle: "Do you use an Assistive Device?",
          testKey: TestKey.UseAssistiveDevice,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle: "Do you have any issues with your vision?",
          testKey: TestKey.IssuesWithVision,
          comments: false,
          commentsText: "",
          commentsPlaceholder: "news",
          examFormChoiceType: "YesNoChoice",
          conditionalStyleRendering: "Row",
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
          ],
        },

        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.RecentFalls,
          subTitle: "Recent Falls",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NoneIn12Months,
              rowTitle: "None in 12 months",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.OneOrMoreBetween3And12Months,
              rowTitle: "One or more between 3 and 12 months",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.OneOrMoreInLast3Months,
              rowTitle: "One or more in last 3 months",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.OneOrMoreInLast3MonthsWhileInResident,
              rowTitle:
                "One or more in last 3 months whilst in-patient/resident",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.FallRiskMedications,
          subTitle:
            "Medications (Sedatives, Anti-depressants, Anti-parkinsons, Diuretics, Anti-hypertensives, hypnotics)",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.NoTakingAnyMedication,
              rowTitle: "No taking any medication",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.TakingOne,
              rowTitle: "Taking one",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.TakingTwo,
              rowTitle: "Taking two",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.TakingMoreThanTwo,
              rowTitle: "Taking more than two",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.FallRiskPsychological,
          subTitle: "Psychological (Anxiety, Depression)",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.DoesNotAppearToHaveAnyOfThese,
              rowTitle: "Does not appear to have any of these",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.AppearsMildlyAffectedByOneOrMore,
              rowTitle: "Appears mildly affected by one or more",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.AppearsModeratelyAffectedByOneOrMore,
              rowTitle: "Appears moderately affected by one or more",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.AppearsSeverelyAffectedByOneOrMore,
              rowTitle: "Appears severely affected by one or more",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          testKey: TestKey.CognitiveStatus,
          subTitle:
            "Cognitive Status (AMTS: Hodkinson Abbreviated Mental Test Score)",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.Amts9or10Or10orIntact,
              rowTitle: "9 or 10 or 10 or Intact",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.Amts7or8OrMildlyImpaired,
              rowTitle: "7 or 8 or Mildly Impaired",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.Amts5or6OrModeratelyImpaired,
              rowTitle: "5 or 6 or Moderately Impaired",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.Amts4orLessOrSeverelyImpaired,
              rowTitle: "4 or less or Severely Impaired",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
      ],
      order: 3,
    },
    {
      examFormId: "ACBD-ACBD-ACBD",
      examTitle: "Step 5: HPC/MOI",
      examFormTests: [
        {
          __typename: "ExamFormTestData",
          testTitle: "4. History of Present Condition",
          testKey: TestKey.HistoryOfPresentCondition,
          comments: true,
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.HpcWhatHappened,
              rowTitle: "Please indicate what happened:",
              examFormDataInputRowType: ExamFormDataInputRowType.TextField,
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "History of Present Condition",
              isTextArea: true,
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.WhenDidOccur,
          comments: true,
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.HpcWhenDidOccur,
              rowTitle: "When did this happen?",
              examFormDataInputRowType: ExamFormDataInputRowType.TextField,
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "History of Present Condition",
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle:
            "Was this pain or discomfort the result of an accident or serious injury? If yes, select the MSK Red Flags that apply:",
          testKey: TestKey.AccidentOrInjury,
          comments: true,
          commentsText: "",
          examFormChoiceType: "MultipleSelect",
          conditional: true,
          examFormChoiceRows: [
            {
              id: TestRowKey.AccidentOrInjuryNoBearWeight,
              rowTitle: "Inability to bear weight on affected area",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.AccidentOrInjuryPhysicalDeformity,
              rowTitle: "Any new physical deformity",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.AccidentOrInjurySeverePain,
              rowTitle: "Severe pain associated with the trauma or injury",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.AccidentOrInjuryNotApplicable,
              rowTitle: "Not applicable",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: true,
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "5. Mechanism of Injury",
          testKey: TestKey.MechanismOfInjury,
          subTitle: "Please indicate how this injury came to be:",
          comments: true,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.MoiGradualOnset,
              rowTitle: "Gradual Onset",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoiSuddenOnset,
              rowTitle: "Sudden, Unexpected Onset",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoiTraumaticImpact,
              rowTitle: "Traumatic Impact",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MoiUnknown,
              rowTitle: "Unknown",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
      ],
      order: 4,
    },
    {
      examFormId: "ADBD-ATBD-ACBG",
      examTitle: "Step 6: Prior Treatment",
      examFormTests: [
        {
          __typename: "ExamFormTestChoice",
          testTitle: "6. Prior Treatment",
          subTitle:
            "Please indicate any prior treatment for the current condition. Select all that apply:",
          testKey: TestKey.PriorTreatment,
          comments: true,
          commentsText: "",
          examFormChoiceType: "MultipleSelect",
          examFormChoiceRows: [
            {
              id: TestRowKey.PriorTreatmentPt,
              rowTitle: "Physical therapy",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.PriorTreatmentMassage,
              rowTitle: "Massage",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.PriorTreatmentChiropractic,
              rowTitle: "Chiropractic",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.PriorTreatmentMedicalIntervention,
              rowTitle: "Medical or surgical intervention",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.PriorTreatmentAcupuncture,
              rowTitle: "Acupuncture",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.PriorTreatmentMedication,
              rowTitle:
                "Topical analgesic, anti-inflammatory, or other pharmaceutical agents",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.PriorTreatmentRest,
              rowTitle: "Rest or modification of normal activities",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.PriorTreatmentOther,
              rowTitle: "Other",
              inputPlaceholder: "Specify other treatments",
              addInputText: true,
              inputTextSize: "Fill",
              isSelected: false,
            },
          ],
          isMultipleSelect: true,
        },
      ],
      order: 5,
    },
    {
      examFormId: "AVBD-ATBD-ACBG",
      examTitle: "Step 7: Pain Assessment",
      examFormTests: [
        {
          __typename: "ExamFormTestData",
          testTitle: "7. Pain Assessment",
          testKey: TestKey.WhatMakesFeelWorse,
          comments: false,
          commentsText: "",
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.WhatMakesFeelWorseRow,
              rowTitle: "What makes your pain feel worse?",
              examFormDataInputRowType: "TextField",
              isTextArea: false,
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "Provider Input",
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.WhatMakesFeelBetter,
          comments: false,
          commentsText: "",
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.WhatMakesFeelBetterRow,
              rowTitle: "What makes your pain feel better?",
              examFormDataInputRowType: "TextField",
              isTextArea: false,
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "Provider Input",
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.BetterOrWorseOverTime,
          comments: false,
          commentsText: "",
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.BetterOrWorseOverTimeRow,
              rowTitle:
                "Is your pain getting better, worse, or staying the same over time?",
              examFormDataInputRowType: "TextField",
              isTextArea: false,
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "Provider Input",
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.HowIntense1To10,
          comments: false,
          commentsText: "",
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.HowIntense1To10Row,
              rowTitle: "On a scale of 0 - 10, how intense is the pain?",
              examFormDataInputRowType: "OneToTenSplitButton",
              labels: [
                "No Pain",
                "",
                "",
                "",
                "",
                "Moderate Pain",
                "",
                "",
                "",
                "",
                "Worst Pain",
              ],
              inputValue: "",
              addInputText: false,
              text: "",
              inputPlaceholder: "Patient Input",
              minLabel: "No Pain",
              maxLabel: "Worst Pain",
              scale: 11,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle:
            "Can you describe what type of pain or discomfort you are feeling?",
          testKey: TestKey.WhatTypeOfPain,
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleSelect",
          examFormChoiceRows: [
            {
              id: TestRowKey.WhatTypeOfPainDull,
              rowTitle: "Dull Pain",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.WhatTypeOfPainAching,
              rowTitle: "Aching Pain",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.WhatTypeOfPainNumbness,
              rowTitle: "Numbness",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.WhatTypeOfPainSharp,
              rowTitle: "Sharp Pain",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.WhatTypeOfPainPinsNeedles,
              rowTitle: "Pins and Needles",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.WhatTypeOfPainRadiating,
              rowTitle: "Radiating Pain",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.WhatTypeOfPainOther,
              rowTitle: "Other",
              addInputText: true,
              inputTextSize: "Fill",
              isSelected: false,
            },
          ],
          isMultipleSelect: true,
        },
      ],
      order: 6,
    },
    // prom form has order 7,
    defaultPlaceHolderProm,
    {
      examFormId: "ADBD-ATBD-AQBG",
      examTitle: "Step 9: Activity & Goals",
      examFormTests: [
        {
          __typename: "ExamFormTestChoice",
          testTitle: "9. Activity & Goals",
          testKey: TestKey.CurrentLevelOfPhysicalActivity,
          subTitle: "What is your level of physical activity?",
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          examFormChoiceRows: [
            {
              id: TestRowKey.CurrentLevelOfPhysicalActivityPhysicallyActive,
              rowTitle:
                "Physically Active (3 hours of exercise or more a week)",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.CurrentLevelOfPhysicalActivityFairlyActive,
              rowTitle: "Fairly Active (1-3 hours of exercise a week)",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.CurrentLevelOfPhysicalActivityInactive,
              rowTitle:
                "Physically Inactive (Less than an hour of exercise a week)",
              addInputText: false,
              isSelected: false,
            },
          ],
          isMultipleSelect: false,
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.ActivityYouCareMost,
          comments: false,
          commentsText: "",
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.ActivityYouCareMostRow,
              rowTitle:
                "What is the activity you care most about that is limited by your condition?",
              isTextArea: true,
              examFormDataInputRowType: "TextField",
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "Patient Input Activity",
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.GoalsYouLikeToAchieve,
          comments: false,
          commentsText: "",
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.GoalsYouLikeToAchieveRow,
              rowTitle:
                "Please share any goals you'd like to achieve during this visit:",
              isTextArea: true,
              examFormDataInputRowType: "TextField",
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "Patient Input Activity",
            },
          ],
        },
      ],
      order: 8,
    },
    {
      examFormId: "ADBD-ATBD-AQBL",
      examTitle: "Step 10: Prior Medical History",
      examFormTests: [
        {
          __typename: "ExamFormTestChoice",
          conditionalStyleRendering: "Row",
          testTitle: "10. Prior Medical History",
          subTitle: "Medical Conditions",
          testKey: TestKey.PriorMedicalHistory,
          comments: true,
          commentsText: "",
          examFormChoiceType: "MultipleSelect",
          examFormChoiceRows: [
            {
              id: TestRowKey.MedHistoryStroke,
              rowTitle: "Stroke",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryHeartDisease,
              rowTitle: "Heart Disease",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryCopd,
              rowTitle: "COPD",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryOsteoporosis,
              rowTitle: "Osteoporosis",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryOsteoarthritis,
              rowTitle: "Osteoarthritis",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryRheumatoidArthritis,
              rowTitle: "Rheumatoid Arthritis",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistorySeizures,
              rowTitle: "Seizures",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryDepression,
              rowTitle: "Depression",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryDvt,
              rowTitle: "Deep Vein Thrombosis (DVT)",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryAsthma,
              rowTitle: "Asthma",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryDiabetes,
              rowTitle: "Diabetes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryHbp,
              rowTitle: "High Blood Pressure",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.MedHistoryThyroidDisease,
              rowTitle: "Thyroid Disease",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          subTitle: "Past Cancer History",
          testKey: TestKey.PastCancerHistory,
          comments: true,
          examFormDataInputType: "ExamFormDataInput",
          conditional: true,
          examFormDataInputRows: [
            {
              id: TestRowKey.PastCancerHistoryRow,
              rowTitle: "",
              examFormDataInputRowType: "MultiDateInput",
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "",
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          subTitle: "Past Surgical History",
          testKey: TestKey.PastSurgicalHistory,
          comments: true,
          examFormDataInputType: "ExamFormDataInput",
          conditional: true,
          examFormDataInputRows: [
            {
              id: TestRowKey.PastSurgicalHistoryRow,
              rowTitle: "",
              examFormDataInputRowType: "MultiDateInput",
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "",
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle: "Substance History",
          testKey: TestKey.SubstanceHistory,
          comments: true,
          commentsText: "",
          examFormChoiceType: "MultipleSelect",
          examFormChoiceRows: [
            {
              id: TestRowKey.SubstanceHistoryTobacco,
              rowTitle: "Tobacco",
              inputTextSize: "Half",
              addInputText: true,
              text: "",
              inputPlaceholder: "Frequency of use if applicable",
              isSelected: false,
            },
            {
              id: TestRowKey.SubstanceHistoryAlcohol,
              rowTitle: "Alcohol",
              inputTextSize: "Half",
              addInputText: true,
              text: "",
              inputPlaceholder: "Frequency of use if applicable",
              isSelected: false,
            },
            {
              id: TestRowKey.SubstanceHistoryOther,
              rowTitle: "Other Substances",
              inputTextSize: "Half",
              addInputText: true,
              text: "",
              inputPlaceholder: "List other substances if applicable",
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.Allergies,
          comments: true,
          conditional: true,
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.AllergiesRow,
              rowTitle: "Allergies?",
              examFormDataInputRowType: "TextField",
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "List allergies",
              isTextArea: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.Medications,
          comments: true,
          conditional: true,
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.MedicationsRow,
              rowTitle: "Rx Medications?",
              examFormDataInputRowType: "TextField",
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "List Rx Medications",
              isTextArea: false,
            }
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.MedicationsOtc,
          comments: true,
          conditional: true,
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.MedicationsOtcRow,
              rowTitle: "Over-the-counter medications?",
              examFormDataInputRowType: "TextField",
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "List OTC medications",
              isTextArea: false,
            }
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.MedicationsSupplements,
          comments: true,
          conditional: true,
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.MedicationsSupplementsRow,
              rowTitle: "Supplements?",
              examFormDataInputRowType: "TextField",
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "List supplements",
              isTextArea: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestChoice",
          testTitle: "",
          subTitle: "Dexa Scan",
          testKey: TestKey.HadDexaScan,
          comments: false,
          commentsText: "",
          examFormChoiceType: "MultipleChoice",
          isMultipleSelect: false,
          examFormChoiceRows: [
            {
              id: TestRowKey.RedYes,
              rowTitle: "Yes",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.RedNo,
              rowTitle: "No",
              addInputText: false,
              isSelected: false,
            },
            {
              id: TestRowKey.NoSure,
              rowTitle: "Not sure",
              addInputText: false,
              isSelected: false,
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.DexaScanDate,
          comments: true,
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.DexaScanDateRow,
              rowTitle: "Date of last scan",
              examFormDataInputRowType: ExamFormDataInputRowType.DateInput,
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "Date of last scan",
            },
          ],
        },
        {
          __typename: "ExamFormTestData",
          testTitle: "",
          testKey: TestKey.DexaScanResult,
          comments: false,
          commentsText: "",
          examFormDataInputType: "ExamFormDataInput",
          examFormDataInputRows: [
            {
              id: TestRowKey.DexaScanResultRow,
              rowTitle: "Scan Result",
              examFormDataInputRowType: "TextField",
              isTextArea: false,
              inputValue: "",
              addInputText: true,
              text: "",
              inputPlaceholder: "Dexa Scan Result",
            },
          ],
        },
      ],
      order: 9,
    },
  ] as SubjectiveExamForm[],
};
